<div class="reset-password-container">
    <div class="language-switcher-container">
        <on-language-switcher></on-language-switcher>
    </div>
    <div class="card">
        <div class="card-body">
            <h4 class="card-title">{{ 'auth.reset-password-title' | translate }}</h4>
            <div *ngIf="!isLoading && email && token">
                <div class="form-group">
                    <label for="">{{ 'auth.your-email' | translate }}:</label>
                    <input
                        type="text"
                        [(ngModel)]="email"
                        disabled
                        class="form-control"
                    />
                </div>
                <div class="form-group">
                    <label>{{ 'auth.new-password' | translate }}:</label>
                    <input
                        type="password"
                        class="form-control"
                        [(ngModel)]="password"
                    />
                </div>
                <div class="form-group">
                    <label>{{ 'auth.confirm-password' | translate }}:</label>
                    <input
                        type="password"
                        class="form-control"
                        [(ngModel)]="confirmation"
                    />
                </div>
                <div>
                    <button (click)="resetPassword()" class="btn btn-primary">
                        {{ 'auth.change-password' | translate }}
                    </button>
                </div>
            </div>
            <div *ngIf="!isLoading && (!email || !token)">
                {{ 'auth.invalid-reset-link' | translate }}
            </div>
            <on-loading *ngIf="isLoading"></on-loading>
        </div>
    </div>
</div>
